<template>
	<svg viewBox="0 0 24 24" aria-hidden="true">
		<path d="M4 8V6a2 2 0 0 1 2-2h2" />
		<path d="M20 8V6a2 2 0 0 0-2-2h-2" />
		<path d="M4 16v2a2 2 0 0 0 2 2h2" />
		<path d="M20 16v2a2 2 0 0 1-2 2h-2" />
		<path d="M7 12h10" />
	</svg>
</template>
